/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManagementCompanyBoardMemberDto } from '../../models/management-company-board-member-dto';

export interface ListBoardMembers$Params {
  managementCompanyId: string;
  active?: boolean;
}

export function listBoardMembers(http: HttpClient, rootUrl: string, params: ListBoardMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManagementCompanyBoardMemberDto>>> {
  const rb = new RequestBuilder(rootUrl, listBoardMembers.PATH, 'get');
  if (params) {
    rb.path('managementCompanyId', params.managementCompanyId, {});
    rb.query('active', params.active, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ManagementCompanyBoardMemberDto>>;
    })
  );
}

listBoardMembers.PATH = '/management-companies/{managementCompanyId}/board-members';
